import React from "react";
import axios from "axios";
import Moment from "react-moment";
import PageTitle from "../../components/common/PageTitle";
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Button,
  Container,
} from "shards-react";

const ITEMS_PER_PAGE = 10;

class Workshops extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      currentPage: 1,
      totalPages: 1,
      pageLimit: ITEMS_PER_PAGE,
      isFetching: false,
    };
  }

  getWorkshopList = (page = 1) => {
    this.setState({ isFetching: true });

    axios
      .get(`${process.env.REACT_APP_API_URL}/admin/atl-tinkerpreneur`, {
        params: { page, limit: ITEMS_PER_PAGE },
        headers: { "x-access-token": localStorage.getItem("jwtToken") },
      })
      .then((res) => {
        this.setState({
          data: res.data.workshops,
          currentPage: res.data.currentPage,
          totalPages: res.data.totalPages,
          isFetching: false,
        });
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        this.setState({ isFetching: false });
      });
  };

  componentDidMount() {
    this.getWorkshopList();
  }

  handlePageChange = (page) => {
    this.getWorkshopList(page);
  };

  editWorkshop = (id) => {
    this.props.history.push(`/workshop/${id}`);
  };

  render() {
    return (
      <React.Fragment>
        <Container fluid className="main-content-container px-4">
          <Row noGutters className="page-header py-4">
            <PageTitle
              sm="4"
              title="AI For Educators Workshops"
              className="text-sm-left"
            />
          </Row>
          <Row>
            <Col>
              <Card small className="mb-4">
                <CardHeader className="border-bottom"></CardHeader>
                <CardBody className="p-0 pb-3">
                  {this.state.data.length > 0 ? (
                    <>
                      <table className="table mb-0" id="my-table">
                        <thead className="bg-light">
                          <tr>
                            <th scope="col" className="border-0 w-5">
                              S.N.
                            </th>
                            <th scope="col" className="border-0">
                              Domain
                            </th>
                            <th scope="col" className="border-0">
                              Workshop Title
                            </th>
                            <th scope="col" className="border-0">
                              Schedule Date
                            </th>
                            <th scope="col" className="border-0">
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.data.map((item, index) => (
                            <tr key={index}>
                              <td>
                                {(this.state.currentPage - 1) *
                                  this.state.pageLimit +
                                  index +
                                  1}
                              </td>
                              <td>{item.domain}</td>
                              <td>{item.title}</td>
                              <td>
                                <Moment format="DD-MMMM-YYYY">
                                  {item.date}
                                </Moment>
                              </td>
                              <td>
                                <div className="d-flex flex-column">
                                  <Button
                                    onClick={() => this.editWorkshop(item._id)}
                                    className="mb-2 btn"
                                    style={{ width: "fit-content" }}
                                  >
                                    Edit
                                  </Button>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      <row>
                        <div className="d-flex justify-content-end">
                          <div className="pagination mt-3 mr-3">
                            <Button
                              outline
                              size="sm"
                              theme="primary"
                              className="mb-2 mr-1"
                              disabled={this.state.currentPage <= 1}
                              onClick={() =>
                                this.handlePageChange(
                                  this.state.currentPage - 1
                                )
                              }
                            >
                              Previous
                            </Button>
                            <span className="mx-2 mt-1">
                              Page {this.state.currentPage} /{" "}
                              {this.state.totalPages}
                            </span>
                            <Button
                              outline
                              size="sm"
                              theme="primary"
                              className="mb-2 mr-1"
                              disabled={
                                this.state.currentPage >= this.state.totalPages
                              }
                              onClick={() =>
                                this.handlePageChange(
                                  this.state.currentPage + 1
                                )
                              }
                            >
                              Next
                            </Button>
                          </div>
                        </div>
                      </row>
                    </>
                  ) : (
                    <div className="d-flex justify-content-center">
                      {" "}
                      <h3>No Data Found</h3>
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default Workshops;
